import TextInputWithError from "../TextInputWithError";
import CheckboxWithError from "../CheckboxWithError";
import DatePickerWithError from "../DatePickerWithError";
import CurrencyInput from "../CurrencyInput";

// Helper function to create date fields with timezone support
const createDateField = (label, name, options = {}) => ({
  InputComponent: DatePickerWithError,
  label,
  name,
  fullWidth: true,
  ...options,
});

export default {
  approvedToPay: {
    name: "approvedToPay",
    InputComponent: CheckboxWithError,
    label: "Approved to Pay",
    ignoreCaption: true,
  },
  shipmentQty: {
    InputComponent: TextInputWithError,
    label: "Quantity",
    name: "quantity",
    fullWidth: true,
    limit: 0,
    limitType: "value",
    InputProps: {
      inputComponent: CurrencyInput,
    },
    inputProps: {
      maskProps: { prefix: "" },
    },
  },
  estimatedShipDate: createDateField("Estimated Ship", "estimatedShipDate", {
    disablePast: true,
  }),
  estimatedDeliveryDate: createDateField(
    "Estimated Delivery",
    "estimatedDeliveryDate",
    { disablePast: true }
  ),
  shipmentTrackingNumber: {
    InputComponent: TextInputWithError,
    label: "Tracking Number",
    name: "trackingNumber",
    fullWidth: true,
  },
  shipmentReceivedBy: {
    InputComponent: TextInputWithError,
    label: "Received By",
    name: "receivedBy",
    fullWidth: true,
  },
  actualShipDate: createDateField("Actual Ship", "actualShipDate"),
  actualDeliveryDate: createDateField("Actual Delivery", "actualDeliveryDate"),
  notes: {
    InputComponent: TextInputWithError,
    label: "Notes",
    name: "notes",
    fullWidth: true,
    multiline: true,
    rows: 2,
  },
};
